import PriceList from "./PriceList";
import Product from "./Product";
import InsulationCut from "./InsulationCut";
import BaseModel from "./BaseModel";
import Customer from "./Customer";

export default class PriceListItem extends BaseModel {

	static entity = 'price_list_items';
	static route = 'price-list-items';
	static plural = 'price_list_items';
	static singular = 'price_list_item';

	static fields () {
		return {
			id: this.attr(null), 
			price_list_id: this.attr(null),
			price_list: this.belongsTo(PriceList, 'price_list_id'),
			product_id: this.attr(null),
			product: this.belongsTo(Product, 'product_id'),
			insulation_cut_id: this.attr(null),
			insulation_cut: this.belongsTo(InsulationCut, 'insulation_cut_id'),
			customer_id: this.attr(null),
			customer: this.belongsTo(Customer, 'customer_id'),
			quantity: this.attr(null),
			cost: this.attr(null),
			custom: this.attr(null),
			custom_name: this.attr(null),
			custom_description: this.attr(null),
			custom_group: this.attr(null),
			created_at: this.attr(null), 
			updated_at: this.attr(null), 
			deleted_at: this.attr(null)
		}
	}

}
